import axios from "axios";

// 全局 API 地址配置
export const API_BASE_URL = "https://heiliaoapi.foyedh.com"; // 主 API 地址

// 通用数据请求方法
export async function fetchData(endpoint, payload = {}) {
  try {
    const response = await axios.post(`${API_BASE_URL}/${endpoint}`, payload);
    return response.data;
  } catch (error) {
    console.error(`Error fetching data from ${endpoint}:`, error);
    throw error;
  }
}